require('airship/thirdparty/closest-polyfill.js')

/**
 * Provides an IE-polyfilled way to use `Element.closest`, protected against the
 * svg limitation of the polyfill.
 */
export default function closest(
  el: HTMLElement,
  selector: string
): Element | null {
  if (el.tagName === 'svg') {
    // Allow the closest polyfill to work by getting the parent, non-svg
    // element. See
    // https://github.com/Financial-Times/polyfill-service/issues/1279
    if (el.parentNode) {
      // @ts-ignore: the polyfill provides closest here:
      return el.parentNode.closest(selector)
    }
    return null
  }
  return el.closest(selector)
}
